module.exports = __webpack_public_path__ + "static/webpack-landing-893a9bea30b0e12016e5857f4829c731.jpg";